import { render, staticRenderFns } from "./SelectedCategories.vue?vue&type=template&id=8f29b81c&"
import script from "./SelectedCategories.vue?vue&type=script&lang=js&"
export * from "./SelectedCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports